import { Link } from "react-router";
import { Facebook, Instagram, LinkedIn, WhatsApp, X } from "@mui/icons-material";

const TEAL = "#4abcc9";
const NAVY = "#0f1719";

const SERVICES = ["Medicina General", "Pediatría", "Ginecología", "Psicología", "Nutrición"];

export default function FooterComponent() {
    return (
        <footer style={{ background: NAVY, padding: "48px 0", color: "#94a3b8", fontFamily: "'Montserrat',sans-serif", margin: 0 }}>
            <div style={{ maxWidth: 1152, margin: "0 auto", padding: "0 24px" }}>
                {/* Grid */}
                <div className="hd-footer-grid" style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr 1fr 1fr", gap: 48, marginBottom: 48 }}>
                    {/* Columna marca */}
                    <div>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 16 }}>
                            <img src="/logos.png" alt="HeyDoctor" style={{ height: 32, objectFit: "contain" }} />
                        </div>
                        <p style={{ fontSize: "0.875rem", lineHeight: 1.7, margin: 0, maxWidth: 260 }}>
                            Plataforma líder en asesoría médica gratuita. Conectamos pacientes con médicos certificados de manera rápida y segura.
                        </p>
                    </div>

                    {/* Servicios */}
                    <div>
                        <h4 style={{ fontSize: "0.8rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: 1.5, color: "white", margin: "0 0 16px" }}>
                            Servicios
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12, fontSize: "0.875rem" }}>
                            {SERVICES.map((s) => (
                                <li key={s} style={{ color: "#94a3b8" }}>{s}</li>
                            ))}
                        </ul>
                    </div>

                    {/* Compañía */}
                    <div>
                        <h4 style={{ fontSize: "0.8rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: 1.5, color: "white", margin: "0 0 16px" }}>
                            Compañía
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12, fontSize: "0.875rem" }}>
                            {[
                                { label: "Acerca de nosotros", to: "/quienes-somos" },
                                { label: "Blog", to: "/blog" },
                            ].map(({ label, to }) => (
                                <li key={label}>
                                    <Link to={to} style={{ color: "#94a3b8", textDecoration: "none" }}>
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Soporte */}
                    <div>
                        <h4 style={{ fontSize: "0.8rem", fontWeight: 800, textTransform: "uppercase", letterSpacing: 1.5, color: "white", margin: "0 0 16px" }}>
                            Soporte
                        </h4>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 12, fontSize: "0.875rem" }}>
                            {[
                                { label: "Términos y condiciones", to: "/terminos-y-condiciones" },
                                { label: "Aviso de privacidad", to: "/aviso-de-privacidad" },
                                { label: "Contáctanos", to: "/contactanos" },
                            ].map(({ label, to }) => (
                                <li key={label}>
                                    <Link to={to} style={{ color: "#94a3b8", textDecoration: "none" }}>
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom bar */}
                <div style={{ borderTop: "1px solid #1e293b", paddingTop: 28, display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
                    <p style={{ margin: 0, color: "#64748b", fontSize: "0.875rem" }}>© 2026 HeyDoctor. Todos los derechos reservados.</p>
                    <div style={{ display: "flex", gap: 10 }}>
                        {[
                            { icon: <WhatsApp sx={{ fontSize: 18 }} />, href: "#" },
                            { icon: <Facebook sx={{ fontSize: 18 }} />, href: "#" },
                            { icon: <Instagram sx={{ fontSize: 18 }} />, href: "#" },
                            { icon: <LinkedIn sx={{ fontSize: 18 }} />, href: "#" },
                            { icon: <X sx={{ fontSize: 18 }} />, href: "#" },
                        ].map(({ icon, href }, i) => (
                            <a
                                key={i}
                                href={href}
                                style={{
                                    width: 36,
                                    height: 36,
                                    borderRadius: "50%",
                                    background: "rgba(255,255,255,0.08)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#94a3b8",
                                    transition: "background .2s",
                                    textDecoration: "none",
                                }}
                            >
                                {icon}
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
}
